import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export type Me = {
  id: number;
  email: string;
  role: "owner" | "support" | "admin";
  has_password: boolean;
};

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => api.me() as Promise<Me>,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}

export function isRole(me: Me | undefined, ...roles: Me["role"][]): boolean {
  return !!me && roles.includes(me.role);
}
